import { render, staticRenderFns } from "./Welcome_HNACS.vue?vue&type=template&id=34025e64&scoped=true&"
import script from "./Welcome_HNACS.vue?vue&type=script&lang=js&"
export * from "./Welcome_HNACS.vue?vue&type=script&lang=js&"
import style0 from "./Welcome_HNACS.vue?vue&type=style&index=0&id=34025e64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34025e64",
  null
  
)

export default component.exports